import gsap from "gsap";

import { Stage } from "./components/stage";
import { loadIntro } from "./components/intro";
import { HoverField } from "./components/hover";
import { CardField } from "./components/ cards";

const canvas = document.getElementById("gl");
const stage = new Stage(canvas);
const field = new CardField(stage);
const hover = new HoverField(stage, field);

let introDone = false;

function frame(_, deltaMs) {
  const dt = Math.min(deltaMs / 1000, 0.05);
  if (introDone) hover.update(dt);
  field.applyAll();
  stage.render();
}

async function init() {
  await field.create();
  document.body.classList.remove("loading");
  gsap.ticker.add(frame);

  loadIntro({
    field,
    onComplete() {
      introDone = true;
      hover.enable();
    },
  });

  window.addEventListener("resize", () => {
    field.resize();
    if (!introDone) return;
    field.cards.forEach((card) => {
      const ring = field.ringPos(card.index);
      card.anim.x = ring.x;
      card.anim.y = ring.y;
      card.anim.rotZ = ring.rotZ;
    });
  });
}

init();
